export const FOOTER_CONTACT_URL = 'https://www.orientaction-groupe.com/contact/';
export const FOOTER_PHONE = '02 43 72 25 88';

export const FOOTER_SERVICES = [
  {
    label: 'Osez le bilan de compétences',
    href: 'https://www.orientaction-groupe.com/qui-sommes-nous/bilan-de-competences/',
  },
  {
    label: 'Trouvez un nouveau job',
    href: 'https://www.orientaction-groupe.com/qui-sommes-nous/outplacement/',
  },
  {
    label: 'Accomplissez le parfait recrutement',
    href: 'https://www.orientaction-groupe.com/qui-sommes-nous/recrutement/',
  },
  {
    label: 'Devenez consultant(e) expert(e)',
    href: 'https://orientactionemploi.softy.pro/offres',
  },
  {
    label: 'Réussir sa création / Reprise d’entreprise',
    href: 'https://www.orientaction-groupe.com/qui-sommes-nous/accompagnement-creation-rerprise-entreprise-cpf/',
  },
  {
    label: 'Réussir sa V.A.E – accompagnement post-recevabilité',
    href: 'https://www.orientaction-groupe.com/qui-sommes-nous/accompagnement-vae/',
  },
  {
    label: 'Réalisez votre bilan d’orientation',
    href: 'https://www.orientaction-groupe.com/qui-sommes-nous/bilan-orientation-collegien-lyceen-etudiant-parcoursup/',
  },
  {
    label: 'Contactez un coach',
    href: 'https://www.orientaction-groupe.com/qui-sommes-nous/contactez-un-coach/',
  },
] as const;

export const FOOTER_QUALIOPI_TEXT =
  "La certification qualité a été délivrée au titre des catégories d'actions suivantes : ACTIONS DE FORMATION - BILANS DE COMPÉTENCES - ACTIONS PERMETTANT DE VALIDER LES ACQUIS DE L'EXPÉRIENCE";

export const FOOTER_EUROPE_TEXT =
  'En 2009 ORIENTACTION® a été sélectionné par la communauté Européenne parmi les 100 projets les plus innovants dans la catégorie innovation sociale.';
